import React from 'react';
import { connect } from 'react-redux';
import { saveCompany, saveCompanyLogo } from '../../reducers/companies';
import ItemEditComponent from '../../components/TextEdit';
import SwitchEditComponent from '../../components/SwitchEdit';
import Select from '../../components/SelectComponent';
import TaxComponent from '../../components/TaxComponent';
import urls from '../../network/urls';
import './companySettings-view.css';

const countries = ['South Africa', 'US', 'Australia', 'Namibia'];
const currencies = ['ZAR', 'USD', 'AUD', 'NAD', 'EUR'];

const Card = ({ title, icon, children, buttonTitle, buttonAction, defaultOpen = true }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="cs-card">
      <div className="cs-card-header" onClick={() => setOpen(!open)}>
        <h3 className="cs-card-title">
          {icon && <i className={icon}></i>}
          {title}
        </h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {buttonTitle && buttonAction && (
            <button className="btn btn-sm btn-info" onClick={(e) => { e.stopPropagation(); buttonAction(); }}>{buttonTitle}</button>
          )}
          <i className={`fas fa-chevron-down cs-card-chevron ${open ? 'open' : ''}`}></i>
        </div>
      </div>
      {open && <div className="cs-card-body">{children}</div>}
    </div>
  );
};

const UserPermissionToggles = ({ group, setGroup, label, prop }) => (
  <div className="cs-permission-group">
    <div className="cs-permission-group-title">{label}</div>
    <SwitchEditComponent header={'Create'} onChangeText={(k, v) => { let t = { ...group }; t[prop] = { ...t[prop], [k]: v }; setGroup(t); }} prop={'c'} value={group[prop] && group[prop]['c']} />
    <SwitchEditComponent header={'Read'} onChangeText={(k, v) => { let t = { ...group }; t[prop] = { ...t[prop], [k]: v }; setGroup(t); }} prop={'r'} value={group[prop] && group[prop]['r']} />
    <SwitchEditComponent header={'Update'} onChangeText={(k, v) => { let t = { ...group }; t[prop] = { ...t[prop], [k]: v }; setGroup(t); }} prop={'u'} value={group[prop] && group[prop]['u']} />
    <SwitchEditComponent header={'Delete'} onChangeText={(k, v) => { let t = { ...group }; t[prop] = { ...t[prop], [k]: v }; setGroup(t); }} prop={'d'} value={group[prop] && group[prop]['d']} />
    {prop === 'appointments' && (
      <SwitchEditComponent header={'Show UserSelect'} onChangeText={(k, v) => { let t = { ...group }; t[prop] = { ...t[prop], [k]: v }; setGroup(t); }} prop={'showUserSelect'} value={group[prop] && group[prop]['showUserSelect']} />
    )}
  </div>
);

const newGroupTemplate = () => ({
  name: '',
  invoices: { c: true, r: true, u: true, d: true },
  settings: { c: true, r: true, u: true, d: true },
  appointments: { c: true, r: true, u: true, d: true, showUserSelect: false },
  expenses: { c: true, r: true, u: true, d: true },
  clients: { c: true, r: true, u: true, d: true }
});

class CompanySettingsPage extends React.Component {
  state = {
    editCompany: {},
    photo: null,
    photoPreview: null,
    showInviteModal: false,
    inviteEmail: '',
    inviteGroup: '',
    inviteError: '',
    showEditUserModal: false,
    currentUser: null,
    showEditGroupModal: false,
    currentUserGroup: null,
    newGroup: newGroupTemplate(),
  }

  componentDidMount() {
    if (this.props.company) {
      this.setState({
        editCompany: JSON.parse(JSON.stringify(this.props.company))
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.company && !prevProps.company) {
      this.setState({
        editCompany: JSON.parse(JSON.stringify(this.props.company))
      });
    }
  }

  compare = () => {
    return JSON.stringify(this.state.editCompany) === JSON.stringify(this.props.company);
  }

  onChangeText = (key, value) => {
    this.setState({
      editCompany: {
        ...this.state.editCompany,
        [key]: value
      }
    });
  }

  handleSave = () => {
    if (window.confirm('Save these details?')) {
      this.props.dispatchSaveCompany(this.state.editCompany);
      if (this.state.photo) {
        const data = new FormData();
        data.append('photo', this.state.photo);
        this.props.dispatchSaveCompanyLogo(data, this.state.editCompany._id);
        this.setState({ photo: null, photoPreview: null });
      }
    }
  }

  handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        photo: file,
        photoPreview: URL.createObjectURL(file)
      });
    }
  }

  validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }

  getUserGroups = () => {
    const company = this.state.editCompany;
    let groups = ['New'];
    if (company && company.userGroups) {
      groups = ['New', ...Object.keys(company.userGroups).sort()];
    }
    return groups;
  }

  addInvite = () => {
    const { inviteEmail, inviteGroup, newGroup, editCompany } = this.state;

    if (!inviteEmail) {
      this.setState({ inviteError: 'Please enter an email' });
      return;
    }
    if (!this.validateEmail(inviteEmail)) {
      this.setState({ inviteError: 'Please enter a valid email' });
      return;
    }
    if (!inviteGroup) {
      this.setState({ inviteError: 'Please select a user group' });
      return;
    }
    if (inviteGroup === 'New' && !newGroup.name) {
      this.setState({ inviteError: 'Please enter a group name' });
      return;
    }

    let groupName = inviteGroup === 'New' ? newGroup.name : inviteGroup;
    let ob = {
      ...editCompany,
      invites: editCompany.invites ? [...editCompany.invites, { email: inviteEmail, group: groupName }] : [{ email: inviteEmail, group: groupName }]
    };

    if (inviteGroup === 'New') {
      let t = {};
      t[newGroup.name] = newGroup;
      ob.userGroups = editCompany.userGroups ? { ...editCompany.userGroups, ...t } : { ...t };
    }

    this.setState({
      editCompany: ob,
      showInviteModal: false,
      inviteEmail: '',
      inviteGroup: '',
      inviteError: '',
      newGroup: newGroupTemplate()
    });
  }

  deleteInvite = (index) => {
    const invites = [...this.state.editCompany.invites];
    invites.splice(index, 1);
    this.setState({
      editCompany: {
        ...this.state.editCompany,
        invites
      }
    });
  }

  removeUser = (userId) => {
    if (window.confirm('Remove this user?')) {
      this.setState({
        editCompany: {
          ...this.state.editCompany,
          users: this.state.editCompany.users.filter(i => i.userId !== userId)
        },
        showEditUserModal: false,
        currentUser: null
      });
    }
  }

  saveEditUser = () => {
    const { currentUser, editCompany, newGroup } = this.state;

    if (!currentUser.group) {
      return;
    }

    let users = [...editCompany.users];
    users.forEach(el => {
      if (el.userId === currentUser.userId) {
        el.group = currentUser.group === 'New' ? newGroup.name : currentUser.group;
        el.name = currentUser.name;
        el.surname = currentUser.surname;
      }
    });

    let ob = { ...editCompany, users };

    if (currentUser.group === 'New' && newGroup.name) {
      let t = {};
      t[newGroup.name] = newGroup;
      ob.userGroups = editCompany.userGroups ? { ...editCompany.userGroups, ...t } : { ...t };
    }

    this.setState({
      editCompany: ob,
      showEditUserModal: false,
      currentUser: null,
      newGroup: newGroupTemplate()
    });
  }

  updateUserGroup = () => {
    const { currentUserGroup, editCompany } = this.state;
    let t = {};
    t[currentUserGroup.name] = currentUserGroup;
    this.setState({
      editCompany: {
        ...editCompany,
        userGroups: editCompany.userGroups ? { ...editCompany.userGroups, ...t } : { ...t }
      },
      showEditGroupModal: false,
      currentUserGroup: null
    });
  }

  renderLogoSection() {
    const company = this.state.editCompany;
    const logoUrl = company.companyLogo ? `${urls.getImages()}/${company.companyLogo}` : null;

    return (
      <div className="cs-logo-section">
        <input type="file" id="logo-upload" accept="image/*" style={{ display: 'none' }} onChange={this.handleLogoChange} />
        {this.state.photoPreview ? (
          <img src={this.state.photoPreview} alt="New logo" className="cs-logo-img" onClick={() => document.getElementById('logo-upload').click()} />
        ) : logoUrl ? (
          <img src={logoUrl} alt="Company logo" className="cs-logo-img" onClick={() => document.getElementById('logo-upload').click()} />
        ) : (
          <div className="cs-logo-placeholder" onClick={() => document.getElementById('logo-upload').click()}>
            <span>Choose Logo</span>
          </div>
        )}
        <div className="cs-company-name">{company.companyName || ''}</div>
        <div className="cs-company-email">{company.EmailAddress || ''}</div>
      </div>
    );
  }

  renderDetailsCard() {
    const company = this.state.editCompany;
    return (
      <Card title="Details" icon="fas fa-building">
        <div className="cs-form-row">
          <ItemEditComponent header={'Company Name'} onChangeText={this.onChangeText} prop={'companyName'} value={company.companyName} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Contact Number'} onChangeText={this.onChangeText} prop={'contactNumber'} value={company.contactNumber} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Email Address'} onChangeText={this.onChangeText} prop={'EmailAddress'} value={company.EmailAddress} />
        </div>
        <div className="cs-form-row">
          <Select header={'Country'} options={countries} onChangeText={this.onChangeText} prop={'country'} value={company.country} />
        </div>
        <div className="cs-form-row">
          <Select header={'Base Currency'} options={currencies} onChangeText={this.onChangeText} prop={'currency'} value={company.currency} />
        </div>
        <div className="cs-form-row">
          <SwitchEditComponent header={'Multi Currency'} onChangeText={this.onChangeText} prop={'multiCurrency'} value={company.multiCurrency} />
        </div>
        {!!company.multiCurrency && (
          <div className="cs-form-row">
            <label>Select Currencies</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
              {currencies.map(c => (
                <label key={c} style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                  <input type="checkbox"
                    checked={company.selectedCurrencies && company.selectedCurrencies.includes(c)}
                    onChange={(e) => {
                      let selected = company.selectedCurrencies ? [...company.selectedCurrencies] : [];
                      if (e.target.checked) selected.push(c);
                      else selected = selected.filter(i => i !== c);
                      this.onChangeText('selectedCurrencies', selected);
                    }}
                  /> {c}
                </label>
              ))}
            </div>
          </div>
        )}
        <div className="cs-form-row">
          <ItemEditComponent header={'VAT#'} onChangeText={this.onChangeText} prop={'VAT'} value={company.VAT} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Tax#'} onChangeText={this.onChangeText} prop={'Tax'} value={company.Tax} />
        </div>
      </Card>
    );
  }

  renderAddressCard() {
    const company = this.state.editCompany;
    return (
      <Card title="Address" icon="fas fa-map-marker-alt">
        <div className="cs-form-row">
          <ItemEditComponent header={'Address Line 1'} onChangeText={this.onChangeText} prop={'addressLine1'} value={company.addressLine1} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Address Line 2'} onChangeText={this.onChangeText} prop={'addressLine2'} value={company.addressLine2} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'City'} onChangeText={this.onChangeText} prop={'city'} value={company.city} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Code'} onChangeText={this.onChangeText} prop={'code'} value={company.code} />
        </div>
      </Card>
    );
  }

  renderPaymentOptionsCard() {
    const company = this.state.editCompany;
    return (
      <Card title="Payment Options" icon="fas fa-credit-card" defaultOpen={false}>
        <div className="cs-form-row">
          <SwitchEditComponent header={'Use PayFast'} onChangeText={this.onChangeText} prop={'payfast'} value={!!company.payfast || company.payfast === 'true'} />
        </div>
        {!!company.payfast && (
          <>
            <div className="cs-form-row">
              <SwitchEditComponent header={'Test PayFast'} onChangeText={this.onChangeText} prop={'payfast_test'} value={company.payfast_test === true || (!!company.payfast_test && company.payfast_test === 'true')} />
            </div>
            <div className="cs-form-row">
              <ItemEditComponent header={'Merchant Id'} onChangeText={this.onChangeText} prop={'payfast_merchant_id'} value={company.payfast_merchant_id} />
            </div>
            <div className="cs-form-row">
              <ItemEditComponent header={'Merchant Key'} onChangeText={this.onChangeText} prop={'payfast_merchant_key'} value={company.payfast_merchant_key} />
            </div>
            <div className="cs-form-row">
              <ItemEditComponent header={'Passphrase'} onChangeText={this.onChangeText} prop={'payfast_passphrase'} value={company.payfast_passphrase} />
            </div>
          </>
        )}
      </Card>
    );
  }

  renderTaxCard() {
    return (
      <Card title="Tax" icon="fas fa-percentage" defaultOpen={false}>
        <TaxComponent updateTax={this.onChangeText} />
      </Card>
    );
  }

  renderUsersCard() {
    const company = this.state.editCompany;
    return (
      <Card title="Users" icon="fas fa-users" buttonTitle="Invite" buttonAction={() => this.setState({ showInviteModal: true, inviteError: '' })}>
        {company.invites && company.invites.map((invite, index) => (
          <div className="cs-user-item" key={`invite-${index}`}>
            <span className="cs-user-action" onClick={() => this.deleteInvite(index)}>
              <i className="fas fa-times"></i>
            </span>
            <span className="cs-user-name">{invite.email}</span>
            <span className="cs-user-badge">({invite.group}{invite.invited ? ' - invite sent' : ' - pending'})</span>
          </div>
        ))}

        {company.users && company.users
          .sort((a, b) => (a.surname || '').localeCompare(b.surname || ''))
          .map((user, index) => (
            <div className="cs-user-item" key={`user-${index}`}>
              <span className="cs-user-action" onClick={() => this.setState({ showEditUserModal: true, currentUser: { ...user } })}>
                <i className="fas fa-ellipsis-v"></i>
              </span>
              <span className="cs-user-name">
                {user.surname}, {user.name}
              </span>
              <span className="cs-user-badge">
                {company.userId === user.userId ? '(owner)' : `(${user.group || 'unassigned'})`}
              </span>
            </div>
          ))}
      </Card>
    );
  }

  renderUserGroupsCard() {
    const company = this.state.editCompany;
    if (!company.userGroups) return null;

    return (
      <Card title="User Groups" icon="fas fa-layer-group" defaultOpen={false}>
        {Object.keys(company.userGroups).sort().map((groupName) => (
          <div className="cs-user-item" key={groupName}>
            <span className="cs-user-action" onClick={() => this.setState({ showEditGroupModal: true, currentUserGroup: { ...company.userGroups[groupName], name: groupName } })}>
              <i className="fas fa-ellipsis-v"></i>
            </span>
            <span className="cs-user-name">{groupName}</span>
          </div>
        ))}
      </Card>
    );
  }

  renderBankDetailsCard() {
    const company = this.state.editCompany;
    return (
      <Card title="Bank Details" icon="fas fa-university" defaultOpen={false}>
        <div className="cs-form-row">
          <ItemEditComponent header={'Bank'} onChangeText={this.onChangeText} prop={'BankName'} value={company.BankName} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Bank Account Type'} onChangeText={this.onChangeText} prop={'BankAccountType'} value={company.BankAccountType} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Bank Account Number'} onChangeText={this.onChangeText} prop={'BankAccountNumber'} value={company.BankAccountNumber} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Bank Branch'} onChangeText={this.onChangeText} prop={'BankBranch'} value={company.BankBranch} />
        </div>
      </Card>
    );
  }

  renderEmailSetupCard() {
    const company = this.state.editCompany;
    return (
      <Card title="Email Setup" icon="fas fa-envelope" defaultOpen={false}>
        <div className="cs-form-row">
          <ItemEditComponent header={'SMTP Server'} onChangeText={this.onChangeText} prop={'companySMTP'} value={company.companySMTP} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Email Password'} onChangeText={this.onChangeText} prop={'companyEmailPassword'} value={company.companyEmailPassword} />
        </div>
        <div className="cs-form-row">
          <ItemEditComponent header={'Out Port'} onChangeText={this.onChangeText} prop={'companyEmailPort'} value={company.companyEmailPort} />
        </div>
        <div className="cs-form-row">
          <SwitchEditComponent header={'Use Secure Email'} onChangeText={this.onChangeText} prop={'companyEmailIsSecure'} value={!!company.companyEmailIsSecure} />
        </div>
        <div className="cs-form-row">
          <SwitchEditComponent header={'Use SSL3'} onChangeText={this.onChangeText} prop={'companyEmailSSL'} value={!!company.companyEmailSSL} />
        </div>
      </Card>
    );
  }

  renderInviteModal() {
    if (!this.state.showInviteModal) return null;
    const userGroups = this.getUserGroups();

    return (
      <div className="cs-modal-overlay" onClick={() => this.setState({ showInviteModal: false, inviteError: '' })}>
        <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
          <div className="cs-modal-title">Invite User</div>

          {this.state.inviteError && <div style={{ color: '#da4a4f', marginBottom: 12, fontSize: 13 }}>{this.state.inviteError}</div>}

          <div className="cs-form-row">
            <label>Email Address</label>
            <input type="email" className="form-control" placeholder="Email Address"
              value={this.state.inviteEmail}
              onChange={(e) => this.setState({ inviteEmail: e.target.value })}
            />
          </div>

          <div className="cs-form-row">
            <label>User Group</label>
            <select className="form-control" value={this.state.inviteGroup}
              onChange={(e) => this.setState({ inviteGroup: e.target.value })}>
              <option value="">Please select</option>
              {userGroups.map(g => <option key={g} value={g}>{g}</option>)}
            </select>
          </div>

          {this.state.inviteGroup === 'New' && this.renderNewGroupForm()}

          <div className="cs-modal-actions">
            <button className="btn btn-secondary btn-sm" onClick={() => this.setState({ showInviteModal: false, inviteError: '' })}>Cancel</button>
            <button className="btn btn-info btn-sm" onClick={this.addInvite}>Invite</button>
          </div>
        </div>
      </div>
    );
  }

  renderEditUserModal() {
    if (!this.state.showEditUserModal || !this.state.currentUser) return null;
    const userGroups = this.getUserGroups();
    const user = this.state.currentUser;

    return (
      <div className="cs-modal-overlay" onClick={() => this.setState({ showEditUserModal: false, currentUser: null })}>
        <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
          <div className="cs-modal-title">Edit User</div>

          <div className="cs-form-row">
            <label>Name</label>
            <input type="text" className="form-control" value={user.name || ''}
              onChange={(e) => this.setState({ currentUser: { ...user, name: e.target.value } })}
            />
          </div>

          <div className="cs-form-row">
            <label>Surname</label>
            <input type="text" className="form-control" value={user.surname || ''}
              onChange={(e) => this.setState({ currentUser: { ...user, surname: e.target.value } })}
            />
          </div>

          <div className="cs-form-row">
            <label>Email</label>
            <div style={{ color: '#666', fontSize: 14 }}>{user.emailAddress || ''}</div>
          </div>

          <div className="cs-form-row">
            <label>User Group</label>
            <select className="form-control" value={user.group || ''}
              onChange={(e) => this.setState({ currentUser: { ...user, group: e.target.value } })}>
              <option value="">Please select</option>
              {userGroups.map(g => <option key={g} value={g}>{g}</option>)}
            </select>
          </div>

          {user.group === 'New' && this.renderNewGroupForm()}

          <div className="cs-modal-actions">
            <button className="btn btn-danger btn-sm" onClick={() => this.removeUser(user.userId)}>Remove</button>
            <button className="btn btn-secondary btn-sm" onClick={() => this.setState({ showEditUserModal: false, currentUser: null })}>Cancel</button>
            <button className="btn btn-info btn-sm" onClick={this.saveEditUser}>Save</button>
          </div>
        </div>
      </div>
    );
  }

  renderEditGroupModal() {
    if (!this.state.showEditGroupModal || !this.state.currentUserGroup) return null;
    const group = this.state.currentUserGroup;

    return (
      <div className="cs-modal-overlay" onClick={() => this.setState({ showEditGroupModal: false, currentUserGroup: null })}>
        <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
          <div className="cs-modal-title">Edit Group: {group.name}</div>

          <UserPermissionToggles label="Appointments" prop="appointments" group={group}
            setGroup={(g) => this.setState({ currentUserGroup: g })} />
          <UserPermissionToggles label="Invoices" prop="invoices" group={group}
            setGroup={(g) => this.setState({ currentUserGroup: g })} />
          <UserPermissionToggles label="Expenses" prop="expenses" group={group}
            setGroup={(g) => this.setState({ currentUserGroup: g })} />
          <UserPermissionToggles label="Clients" prop="clients" group={group}
            setGroup={(g) => this.setState({ currentUserGroup: g })} />
          <UserPermissionToggles label="Settings" prop="settings" group={group}
            setGroup={(g) => this.setState({ currentUserGroup: g })} />

          <div className="cs-modal-actions">
            <button className="btn btn-secondary btn-sm" onClick={() => this.setState({ showEditGroupModal: false, currentUserGroup: null })}>Cancel</button>
            <button className="btn btn-info btn-sm" onClick={this.updateUserGroup}>Save</button>
          </div>
        </div>
      </div>
    );
  }

  renderNewGroupForm() {
    const { newGroup } = this.state;
    return (
      <div style={{ marginTop: 12, padding: 12, background: '#f8fafc', borderRadius: 8 }}>
        <div className="cs-form-row">
          <label>Group Name</label>
          <input type="text" className="form-control" placeholder="Group Name"
            value={newGroup.name}
            onChange={(e) => this.setState({ newGroup: { ...newGroup, name: e.target.value } })}
          />
        </div>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 8, color: '#1a3a4a' }}>Group Permissions</div>
        <UserPermissionToggles label="Appointments" prop="appointments" group={newGroup}
          setGroup={(g) => this.setState({ newGroup: g })} />
        <UserPermissionToggles label="Invoices" prop="invoices" group={newGroup}
          setGroup={(g) => this.setState({ newGroup: g })} />
        <UserPermissionToggles label="Expenses" prop="expenses" group={newGroup}
          setGroup={(g) => this.setState({ newGroup: g })} />
        <UserPermissionToggles label="Clients" prop="clients" group={newGroup}
          setGroup={(g) => this.setState({ newGroup: g })} />
        <UserPermissionToggles label="Settings" prop="settings" group={newGroup}
          setGroup={(g) => this.setState({ newGroup: g })} />
      </div>
    );
  }

  render() {
    const hasChanges = !this.compare();

    if (!this.state.editCompany || !this.state.editCompany._id) {
      return (
        <div className="content-wrapper p-2 company-settings-container">
          <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: 24 }}></i>
            <p style={{ marginTop: 12 }}>Loading company settings...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="content-wrapper p-2 company-settings-container">
        <div className="company-settings-page-header">
          <h1 className="company-settings-page-title">
            <i className="fas fa-building"></i>
            Company Settings
            {hasChanges && <span className="company-settings-unsaved">(unsaved changes)</span>}
          </h1>
          <button className="company-settings-save-btn" onClick={this.handleSave}>
            <i className="fas fa-save"></i>
            Save
          </button>
        </div>

        {this.renderLogoSection()}
        {this.renderDetailsCard()}
        {this.renderAddressCard()}
        {this.renderPaymentOptionsCard()}
        {this.renderTaxCard()}
        {this.renderUsersCard()}
        {this.renderUserGroupsCard()}
        {this.renderBankDetailsCard()}
        {this.renderEmailSetupCard()}

        {this.renderInviteModal()}
        {this.renderEditUserModal()}
        {this.renderEditGroupModal()}

        <div style={{ height: 100 }}></div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  company: state.companies.company,
  loading: state.companies.loading,
  user: state.auth.user,
});

const mapDispatchToProps = {
  dispatchSaveCompany: (company) => saveCompany(company),
  dispatchSaveCompanyLogo: (data, companyId) => saveCompanyLogo(data, companyId),
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanySettingsPage);
